import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-schemes-menu',
  templateUrl: './schemes-menu.component.html',
  styleUrls: ['./schemes-menu.component.css']
})
export class SchemesMenuComponent implements OnInit {
  menuList:any;
  pageList:any;
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Schemes')      
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/schemes/schemes-menu/schemes-menu.component.ts